<template>
    <div>
        <span class="block text-center text-2xl font-bold mb-8">{{ $t('resultTestENTAndKT') }}</span>
        <vs-checkbox v-model="iDidNotTakeTest" :disabled="disabled">
            {{ $t('iDidNotTakeTest') }}
        </vs-checkbox>
        <template v-if="!iDidNotTakeTest">
            <form data-vv-scope="certificate" class="mt-8">
                <vs-card>
                    <span class="text-xl font-semibold pr-2">{{ $t('dataOfCertificate') }}</span>
                    <div :class="classForDOM.parent">
                        <div :class="classForDOM.block">
                            <MultiselectCustom endpoint="organizations/languages/"
                                               :disabled="disabled"
                                               name="language"
                                               v-validate="'required'"
                                               :placeholder="`${ $t('language') }*`"
                                               v-model="certificate.language"/>
                            <ValidateText field="language" scope="certificate" :error="errors"/>
                        </div>
                    </div>
                    <div :class="classForDOM.parent">
                        <div :class="classForDOM.block">
                            <DatepickerCustom v-model="certificate.issued_at"
                                              :disabled="disabled"
                                              name="issued_at"
                                              v-validate="'required'"
                                              :placeholder="`${ $t('issued_at') }*`"/>
                            <ValidateText field="issued_at" scope="certificate" :error="errors"/>
                        </div>
                        <div :class="classForDOM.block">
                            <DatepickerCustom v-model="certificate.test_date"
                                              :disabled="disabled"
                                              name="test_date"
                                              v-validate="'required'"
                                              :placeholder="`${ $t('test_date') }*`"/>
                            <ValidateText field="test_date" scope="certificate" :error="errors"/>
                        </div>
                    </div>
                    <div :class="classForDOM.parent">
                        <div :class="classForDOM.block">
                            <vs-input :label-placeholder="`${ $t('number') }`"
                                      :disabled="disabled"
                                      v-validate="'required'"
                                      name="number"
                                      v-model="certificate.number"
                                      class="mt-8 flex-auto p-1 w-full"/>
                            <ValidateText field="number" scope="certificate" :error="errors"/>
                        </div>
                        <div :class="classForDOM.block">
                            <vs-input :label-placeholder="`${ $t('series') }`"
                                      :disabled="disabled"
                                      name="series"
                                      v-model="certificate.series"
                                      class="mt-8 flex-auto p-1 w-full"/>
                        </div>
                    </div>
                    <template v-if="file_upload_limitation">
                        <span class="text-base font-medium pt-4 block pl-2">{{ $t('upload_the_required_documents') }}*</span>
                        <span v-if="!certificate.files.length" class="pl-2 text-danger" >{{ $t('please_add_files') }}</span>
                        <div :class="classForDOM.parent">
                            <vs-upload
                                :text="$t('upload_file')"
                                :action="'common/upload/'"
                                :disabled="disabled"
                                @on-success="setCertificateFiles"
                                @prev-delete="removeCertificateFile"
                                :single-upload="true"
                                :firstFiles="certificate.files"
                                :automatic="true"
                                :max-size="file_upload_limitation['max_file_size']"
                                :fileName="'path'"
                            />
                        </div>
                    </template>
                </vs-card>
            </form>

            <vs-card v-if="subjects.length">
                <span class="text-xl font-semibold pr-2">{{ $t('resultTestENTAndKT') }}</span>
                <div class="member-information mt-4 ml-4">
                    <table>
                        <tr v-for="subject in subjects" :key="subject.uid">
                            <td class="text-base font-semibold pr-20 pb-2">
                                {{ subject['discipline_name'] }}
                            </td>
                            <td class="text-base pr-4 pb-2">
                                {{ subject.score }} {{ $t('mark') }}
                            </td>
                            <td v-if="!disabled" class="flex">
                                <vs-button type="relief"
                                           @click="editSubjectWithMark(subject)"
                                           icon="edit"
                                           color="warning">
                                    <!-- {{ $t('edit') }} -->
                                </vs-button>
                                 <vs-button 
                                 class="ml-2"
                                 type="relief"
                                           @click="removeSubjectWithMark(subject)"
                                           icon="delete"
                                           color="danger">
                                           
                                    <!-- {{ $t('remove') }} -->
                                </vs-button>
                            </td>
                            <td v-if="!disabled">
                               
                            </td>
                            <td class="block md:hidden">
                                <vs-divider></vs-divider>
                            </td>
                        </tr>
                    </table>
                </div>
            </vs-card>
        </template>
        <template v-if="!iDidNotTakeTest">
            <div :class="classForDOM.grandParent" class="mb-4">
                <span
                    class="text-danger text-sm"
                    v-if="(subjects && subjects.length < minCountSubjects) || !subjects.length">
                    {{ $t('subject2numberAddRequest') }}
                </span>
            </div>
            <vs-button type="relief"
                       v-if="subjects.length < 5 && !disabled"
                       @click="showModalAddSubjectWithMark">
                {{ $t('addSubjectWithMark') }}
            </vs-button>
        </template>
        <vs-popup color="primary"
                  :active.sync="statusModalAddSubjectWithMark"
                  class="custom-popup"
                  :title="$t(objectForEditSubjectWithMark ? 'edit_subject_with_mark_title' : 'add_subject_with_mark_title')">
            <SubjectWithMarkForm :applicantUid="data.profile.uid"
                                 :objectForEditSubjectWithMark="objectForEditSubjectWithMark"
                                 v-if="statusModalAddSubjectWithMark"
                                 @setObjectSubjectWithMark="setObjectSubjectWithMark"/>
        </vs-popup>
    </div>
</template>

<script>
import MultiselectCustom from "@/pages/Home/FillingInTheApplicantsData/widgets/MultiselectCustom";
import ValidateText from "@/pages/Home/FillingInTheApplicantsData/widgets/ValidateText";
import DatepickerCustom from "@/pages/Home/FillingInTheApplicantsData/widgets/DatepickerCustom";
import SubjectWithMarkForm from "@/pages/Home/FillingInTheApplicantsData/Declaration/components/SubjectWithMarkForm";

export default {
    name: "CertificateOfTestENTAndKT",
    components: {
        MultiselectCustom,
        ValidateText,
        DatepickerCustom,
        SubjectWithMarkForm
    },
    props: {
        file_upload_limitation: {
            type: Object,
            required: true
        },
        data: {
            type: Object,
            required: true
        },
        disabled: {
            type: Boolean,
            default: false,
        }
    },
    data(){
        return {
            iDidNotTakeTest: true,
            certificate: {
                profile: this.data.profile.uid,
                language: "",
                test_date: "",
                issued_at: "",
                series: "",
                number: "",
                files: [],
                uid: null,
            },
            subjects: [],
            minCountSubjects: 2,
            classForDOM: {
                grandParent: 'flex flex-col md:flex-row justify-between',
                parent: 'flex flex-col md:flex-row justify-between items-start',
                block: 'flex flex-col w-full',
            },
            statusModalAddSubjectWithMark: false,
            objectForEditSubjectWithMark: null,
        }
    },
    methods:{
        async saveCertificate(){
            try {
                this.$vs.loading();

                const newCertificate = this.certificate?.uid;

                const clone = { ...this.certificate };

                clone.files = clone.files.map(e => e.response.uid);

                const response = (await this.$http[newCertificate ? 'patch' : 'post'](
                    `admissions/exam-certificates/${ newCertificate ? newCertificate + '/' : '' }`,
                    clone
                )).data

                this.certificate.uid = response.uid

            } catch (e){

            } finally {
                this.$vs.loading.close();
            }
        },
        setCertificateFiles(response){
            if (!this.certificate.files) this.certificate.files = [];
            if (this.certificate.files.findIndex(({ name }) => name === response[0].name)){
                const firstFiles = this.certificate.files.filter((i) => i.firstFile || i.name !== response[0].name);
                const newFiles = response.map((item) => {
                    return {
                        ...item,
                        response: item,
                    };
                });
                this.certificate.files = firstFiles.concat(newFiles);
            } else {
                this.certificate.files = this.certificate.files.concat(
                    response.map((item) => {
                        return {
                            ...item,
                            response: item,
                        };
                    })
                );
            }
        },
        async removeCertificateFile({ file, done }){
            this.certificate.files = await this.certificate.files.filter((item) => item.response.uid !== file.response.uid);
            done();
        },
        async removeCertificate(){
            try {
                this.$vs.loading();

                (await this.$http.patch(
                    `admissions/applicants/${ this.data.uid }/`,
                    {
                        "exam_not_passed": true
                    }
                )).data

            } catch (e){

            } finally {
                this.$vs.loading.close();
            }
        },
        validateStep(){
            if (!this.disabled){
                if(this.iDidNotTakeTest){
                    this.removeCertificate()
                    return true
                } else {
                    return this.$validator.validateAll('certificate').then(async (result) => {
                        if (result && this.subjects.length >= this.minCountSubjects) {
                            // Делаю запросы на сохранение и пропускаю клиента на следующий шаг
                            await this.saveCertificate();

                            await this.$emit('setNewDataInObject', {
                                name: 'subjects',
                                data: this.subjects,
                            })
                            await this.$emit('setNewDataInObject', {
                                name: 'exam',
                                data: this.certificate,
                            })
                            return true
                        }
                        else
                            return false

                    })
                }
            } else {
                return true
            }
        },
        showModalAddSubjectWithMark(){
            this.statusModalAddSubjectWithMark = true;
        },
        closeModalAddSubjectWithMark(){
            this.statusModalAddSubjectWithMark = false;
        },
        setObjectSubjectWithMark(object){
            if(this.subjects.some(p => p.uid === object.uid)){
                this.subjects = this.subjects.map(p => p.uid === object.uid ? object : p)
            } else {
                this.subjects.push(object)
            }
            this.closeModalAddSubjectWithMark()
        },
        editSubjectWithMark(object){
            this.objectForEditSubjectWithMark = object;
            this.showModalAddSubjectWithMark();
        },
        async removeSubjectWithMark(object){
            try {
                this.$vs.loading();

                await this.$http.delete(`admissions/subjects/${ object.uid }/`);
                this.subjects = await this.subjects.filter(e => e.uid !== object.uid);

            } catch (e){

            } finally {
                this.$vs.loading.close();
            }
        },
    },
    created() {
        if (this.data.subjects){
            this.subjects = this.data.subjects;
        }
        if(this.data['exam']){
            for (let key in this.certificate){


                if (key === 'files'){
                    const path = this.data['exam'].files;

                    this.certificate['files'] = path.map(f => {
                        return {
                            firstFiles: true,
                            ...f,
                            response: f,
                        }
                    })
                } else {
                    this.certificate[key] = this.data['exam'][key];
                }
            }
        }
        if(this.data['exam'] && this.data.subjects){
            this.iDidNotTakeTest = false;
        }
    },
    watch: {
        'statusModalAddSubjectWithMark'(){
            if(!this.statusModalAddSubjectWithMark){
                this.objectForEditSubjectWithMark = null;
            }
        },
        'iDidNotTakeTest'(){
            if (this.iDidNotTakeTest){

                this.$vs.dialog({
                    type:'confirm',
                    color: 'danger',
                    title: this.$t('attention'),
                    text: this.$t('youDeletedCertificateText'),
                    accept: () => {
                        for (let key in this.certificate){
                            if(key === 'files'){
                                this.certificate.files = []
                            } else if (key !== 'profile'){
                                this.certificate[key] = '';

                            }
                        }

                        this.subjects = [];

                        this.removeCertificate()
                    },
                    acceptText: this.$t('i_agree'),
                    cancelText: this.$t('i_changed_my_mind'),
                    cancel: () => {
                        this.iDidNotTakeTest = false;
                    }
                })

            }
        }
    }
}
</script>

<style scoped lang="scss">
.member-information{
    table {
        td {
            vertical-align: top;
            min-width: 140px;
            padding-bottom: .8rem;
            word-break: break-all;
        }
        &:not(.permissions-table) {
            td {
                @media screen and (max-width: 600px) {
                    display: block;
                }
            }
        }
    }
}
</style>
